import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import React from "react";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DecoratorNode } from "lexical";
import { VariableComponent } from "./variable-component";

/** Serialized form of a variable node. */

/** Converts a `span[data-variable-node]` into a variable node during HTML import. */
function convertVariableElement(element) {
  var _element$getAttribute, _element$getAttribute2;
  return {
    node: $createVariableNode((_element$getAttribute = element.getAttribute("data-label")) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : "", (_element$getAttribute2 = element.getAttribute("data-value")) !== null && _element$getAttribute2 !== void 0 ? _element$getAttribute2 : undefined)
  };
}

/** Inline decorator node for a template variable. */
export var VariableNode = /*#__PURE__*/function (_DecoratorNode) {
  function VariableNode(label, value, key) {
    var _this;
    _classCallCheck(this, VariableNode);
    _this = _callSuper(this, VariableNode, [key]);
    _this.__label = label;
    _this.__value = value;
    return _this;
  }
  _inherits(VariableNode, _DecoratorNode);
  return _createClass(VariableNode, [{
    key: "getLabel",
    value: function getLabel() {
      return this.__label;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.getLatest().__value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.getWritable().__value = value || undefined;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return {
        type: "variable",
        version: 1,
        label: this.__label,
        value: this.__value
      };
    }
  }, {
    key: "exportDOM",
    value: function exportDOM() {
      var _this$__value;
      var span = document.createElement("span");
      span.setAttribute("data-variable-node", "true");
      span.setAttribute("data-label", this.__label);
      if (this.__value !== undefined) span.setAttribute("data-value", this.__value);
      span.textContent = (_this$__value = this.__value) !== null && _this$__value !== void 0 ? _this$__value : "[".concat(this.__label, "]");
      return {
        element: span
      };
    }
  }, {
    key: "createDOM",
    value: function createDOM() {
      return document.createElement("span");
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "decorate",
    value: function decorate() {
      return /*#__PURE__*/React.createElement(VariableComponent, {
        label: this.__label,
        value: this.__value,
        nodeKey: this.getKey()
      });
    }
  }, {
    key: "isInline",
    value: function isInline() {
      return true;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "variable";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new VariableNode(node.__label, node.__value, node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON(serialized) {
      return $createVariableNode(serialized.label, serialized.value);
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        span: function span(element) {
          return element.getAttribute("data-variable-node") === "true" ? {
            conversion: convertVariableElement,
            priority: 1
          } : null;
        }
      };
    }
  }]);
}(DecoratorNode);

/** Creates a variable node. */
export function $createVariableNode(label, value) {
  return new VariableNode(label, value);
}

/** Type guard for variable nodes. */
export function $isVariableNode(node) {
  return node instanceof VariableNode;
}